import { useCallback, useEffect, useState } from 'react'
import { contentServiceGet } from '../../../lib/utils'
import { CollectionResponse } from '../types'

export default function useFetchCollections(url: string | null | undefined) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState()
  const [value, setValue] = useState<CollectionResponse>()

  const callbackMemoized = useCallback(() => {
    setLoading(true)
    setError(undefined)
    setValue(undefined)
    contentServiceGet(url)
      .then(setValue)
      .catch(setError)
      .finally(() => setLoading(false))
  }, [url])

  useEffect(() => {
    callbackMemoized()
  }, [callbackMemoized])

  return { loading, error, value }
}
